module.exports = __webpack_public_path__ + "static/img/bg-12.ef55d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-12.png
// module id = 6u1c
// module chunks = 0